import { IoSettingsOutline } from "react-icons/io5";
import { LiaUserShieldSolid } from "react-icons/lia";
import { MdChecklist } from "react-icons/md";
import {
  PiCalendarPlus,
  PiCoins,
  PiFlagBannerFoldBold,
  PiHeartStraightFill,
  PiUsersThree,
} from "react-icons/pi";
import { RiHomeLine } from "react-icons/ri";
import { SiMercadopago } from "react-icons/si";
import { TbFileCertificate, TbReportMoney } from "react-icons/tb";

import { UserRole } from "@prisma/client";
import MenuLink from "./MenuLink";
import { BsBoxSeam } from "react-icons/bs";
import { GrPowerCycle } from "react-icons/gr";
import { FaWhatsapp } from "react-icons/fa6";
import { ImStatsBars } from "react-icons/im";

const MenuLinks = ({
  user,
}: {
  user: { groupId: string | null; roles: UserRole[] };
}) => {
  return (
    <ul role="list" className="-mx-2 flex flex-col space-y-1 text-white">
      <MenuLink href="/admin">
        <RiHomeLine className="h-auto w-6" />
        <div className="flex w-full">
          <span className="flex-1">Inicio</span>
        </div>
      </MenuLink>

      {user.groupId === null && user.roles.includes("ADMIN") && (
        <MenuLink href="/admin/usage">
          <ImStatsBars className="h-auto w-6" />
          <div className="flex w-full">
            <span className="flex-1">Estadisticas</span>
          </div>
        </MenuLink>
      )}

      <MenuLink href="/admin/miembros">
        <PiUsersThree className="h-auto w-6" />
        <div className="flex w-full">
          <span className="flex-1">Lista de miembros</span>
        </div>
      </MenuLink>
      {user.groupId ? (
        <MenuLink href="/admin/mi-grupo">
          <PiFlagBannerFoldBold className="h-auto w-6" />
          <div className="flex w-full">
            <span className="flex-1">Mi grupo</span>
          </div>
        </MenuLink>
      ) : (
        <MenuLink href="/admin/grupos">
          <PiFlagBannerFoldBold className="h-auto w-6" />
          <div className="flex w-full">
            <span className="flex-1">Lista de grupos</span>
          </div>
        </MenuLink>
      )}

      <>
        <MenuLink href="/admin/anualidades/pagos">
          <PiCoins className="h-auto w-6" />
          <div className="">Pago de anualidades</div>
        </MenuLink>
        {(user.roles.includes("GRANTS") || user.roles.includes("ADMIN")) &&
          user.groupId === null && (
            <MenuLink href="/admin/anualidades/becas">
              <PiHeartStraightFill className="h-auto w-6" />
              <div className="">Becas de anualidad</div>
            </MenuLink>
          )}
        {user.groupId !== null && (
          <MenuLink href="/admin/finanzas">
            <TbReportMoney className="h-auto w-6" />
            <div className="">Finanzas</div>
          </MenuLink>
        )}
        <MenuLink href="/admin/inventario">
          <BsBoxSeam className="h-auto w-6" />
          <div className="flex w-full">
            <span className="flex-1">Inventario</span>
          </div>
        </MenuLink>
      </>

      {user.groupId && (
        <MenuLink href="/admin/asistencias">
          <MdChecklist className="h-auto w-6" />
          <div className="">Asistencias</div>
        </MenuLink>
      )}

      <MenuLink href="/admin/actividades">
        <PiCalendarPlus className="h-auto w-6" />
        <div className="">Calendario de actividades</div>
      </MenuLink>

      {user.groupId === null && (
        <MenuLink href="/admin/certificados">
          <TbFileCertificate className="h-auto w-6" />
          <div className="">Certificados</div>
        </MenuLink>
      )}

      <>
        <MenuLink href="/admin/usuarios">
          <LiaUserShieldSolid className="h-auto w-6" />
          <div className="flex w-full">
            <span className="flex-1">Usuarios</span>
          </div>
        </MenuLink>
        {user.groupId !== null && (
          <MenuLink href="/admin/preferencias">
            <IoSettingsOutline className="h-auto w-6" />
            <div className="flex w-full">
              <span className="flex-1">Preferencias</span>
            </div>
          </MenuLink>
        )}
        <MenuLink href="https://wa.me/+59899473488">
          <FaWhatsapp className="h-auto w-6" />
          <div className="flex w-full">
            <span className="flex-1">Ayuda</span>
          </div>
        </MenuLink>
      </>
    </ul>
  );
};

export default MenuLinks;
